import React, { createContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';

const breakpoints = {
  sm: 576, // inclusive
  md: 768,
  // lg: 992, // not needed unless we add higher breakpoints
} as const;

let mockedInnerWidth: number | null = null;
export const setMockedInnerWidth = (width: number | null) => {
  mockedInnerWidth = width;
  defaultValue.mobileView = (width || 10000) <= breakpoints.md;
  defaultValue.sm = (width || 10000) <= breakpoints.sm;
};

// make the default widescreen so all existing tests pass
const defaultValue = {
  width: 10000,
  height: 10000,
  sm: false,
  md: false,
  lg: true,
  mdDown: false,
  mdUp: false,
  mobileView: window.innerWidth <= breakpoints.md,
  overrideDesktop: false,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  setOverrideDesktop: (override: boolean) => {},
};

export const ResponsiveContext = createContext(defaultValue);

// get dimensions by tapping "Processing Sheets" heading 6 times...
//              Browser (w/ URL Bar)        PWA
// Device       Portrait      Landscape     Portrait      Landscape
// iPhone 8      375 x 548     667 x 325     375 x 667     667 x 375
// iPhone 12     390 x 664     750 x 339     390 x 797     750 x 390
// iPad Mini     744 x 1059   1133 x 670     744 x 1109   1133 x 720
// iPad          810 x 1010   1080 x 740     810 x 1060   1080 x 790
// iPad Pro 11"  834 x 1120   1194 x 760     834 x 1170   1194 x 810
// iPad Pro 13" 1024 x 1292   1366 x 950    1024 x 1342   1366 x 1000

// eslint-disable-next-line @typescript-eslint/naming-convention
const ResponsiveProvider = withRouter(({ children, history }) => {
  const [windowSize, setWindowSize] = useState(defaultValue);
  const [overrideDesktop, setOverrideDesktop] = useState(false);

  // listener for window resizing and scroll
  useEffect(() => {
    function handleResize() {
      let width = mockedInnerWidth || window.innerWidth;
      let height = window.innerHeight;

      if (overrideDesktop) {
        width = 10000;
        height = 10000;
      }

      setWindowSize({
        width,
        height,
        sm: width <= breakpoints.sm,
        md: width > breakpoints.sm && width <= breakpoints.md,
        lg: width > breakpoints.md,
        mdDown: width <= breakpoints.md,
        mdUp: width > breakpoints.sm,
        mobileView: width <= breakpoints.md,
        overrideDesktop,
        setOverrideDesktop,
      });
    }

    // add event listener and then call handler right away so state gets updated with initial window size
    window.addEventListener('resize', handleResize);
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, [setOverrideDesktop, overrideDesktop]); // Empty array ensures that effect is only run on mount

  // listener for scrolling to top on navigation https://stackoverflow.com/a/54343182
  useEffect(() => {
    const removeListener = history.listen(() => {
      window.scrollTo(0, 0);
    });
    return () => removeListener();
  }, []);

  return (
    <ResponsiveContext.Provider value={windowSize}>
      {children}
    </ResponsiveContext.Provider>
  );
});

export default ResponsiveProvider;
